import { APP_PROVIDERS } from './app/app.providers';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import {
  UserState,
  AppEnvironmentState,
  ActionRequiredState,
  FeatureFlagConfigurationState,
  PermissionsState,
} from '@gea/digital-ui-lib';
import { environment } from '@environments/environment';

import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';

export const ngxsStates = [
  UserState,
  AppEnvironmentState,
  ActionRequiredState,
  FeatureFlagConfigurationState,
  PermissionsState,
];

@NgModule({
  imports: [
    RouterModule,
    NgxsModule.forRoot(ngxsStates, {
      developmentMode: !environment.production,
      compatibility: { strictContentSecurityPolicy: true },
    }),
    NgxsReduxDevtoolsPluginModule.forRoot({
      name: 'TotalCare Partner',
      disabled: environment.production,
      maxAge: 25,
      actionSanitizer: (action) => {
        console.warn(action.type, action);
        return action;
      },
    }),
    NgxsLoggerPluginModule.forRoot({
      disabled: environment.production,
      filter: (action) => (action?.type ? action.type.includes('QueryParameters') : false),
    }),
    NgxsRouterPluginModule.forRoot(),
  ],
  exports: [RouterModule, NgxsModule, TranslateModule],
  providers: [...APP_PROVIDERS],
})
export class AppCommonModule { }
